import { Button } from "@utp/react-components-prod";
import ImgActivity from "assets/img/activity.svg";
import { CcModal } from "@utp/components-react";

interface Props {
  isOpen: boolean;
  onConfirm: () => void;
}

const ModalEvaluationFinished = ({ isOpen, onConfirm }: Props) => {
  return (
    <div className="flex justify-center mb-xxlg modal-finished">
      <CcModal visible={isOpen} hideCloseButton>
        <div className="flex justify-center mb-14">
          <img src={ImgActivity} alt="clock" />
        </div>
        <div className="mb-lg">
          <h2 className="font-black text-heading-02 text-color-02 mb-lg text-center">
            ¡Listo!
          </h2>
          <p className="text-center text-color-02">
            Tu examen de admisión ha sido enviado, <br />
            ¡Te deseamos los mejores éxitos!
          </p>
        </div>
        <div className="flex justify-center gap-lg modal-buttons">
          <Button text="Entiendo" color="primary" onClick={() => onConfirm()} data-testid="btn-confirm" />
        </div>
      </CcModal>
    </div>
  );
};

export default ModalEvaluationFinished;
